let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ghi6m")).then(() => parcelRequire('7QWuh'));